import { fileExtension } from './mediaFileTypes';

export function isHeicPath(relativePath: string): boolean {
  const ext = fileExtension(relativePath);
  return ext === 'heic' || ext === 'heif';
}

export async function convertHeicBlobToJpeg(blob: Blob): Promise<Blob> {
  const { default: heic2any } = await import('heic2any');
  const result = await heic2any({
    blob,
    toType: 'image/jpeg',
    quality: 0.92
  });
  const converted = Array.isArray(result) ? result[0] : result;
  if (!(converted instanceof Blob)) {
    throw new Error('HEIC conversion failed.');
  }
  return converted;
}
